module.exports = __webpack_public_path__ + "images/feature/ical-sub-2-989758241903d7f1480756d6318c9324.jpg";